import ForgotPassword from './pages/auth/ForgotPassword'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAuthStore } from './store/authStore'

// Pages
import LandingPage from './pages/LandingPage'
import TermsAndConditions from './pages/TermsAndConditions'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Login from './pages/auth/Login'
import Register from './pages/auth/Register'
import Dashboard from './pages/Dashboard'
import Quinielas from './pages/Quinielas'
import QuinielaDetail from './pages/QuinielaDetail'
import QuinielaPredictions from './pages/QuinielaPredictions'
import Profile from './pages/Profile'
import Wallet from './pages/Wallet'
import AdminPanel from './pages/admin/AdminPanel'
import OperatorPanel from './pages/operator/OperatorPanel'
import CreateQuiniela from './pages/operator/CreateQuiniela'
import EditQuiniela from './pages/operator/EditQuiniela'
import QuinielaResults from './pages/operator/QuinielaResults'
import ValidarPagos from './pages/operator/payments'
import Usuarios from './pages/operator/Usuarios'
import Withdrawals from './pages/operator/Withdrawals'

// Components
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  const { user, loading } = useAuthStore()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/register" element={user ? <Navigate to="/dashboard" /> : <Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />


        {/* Protected routes */}
        <Route element={<Layout />}>
          <Route path="/terminos" element={<TermsAndConditions />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quinielas"
            element={
              <ProtectedRoute>
                <Quinielas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quinielas/:id"
            element={
              <ProtectedRoute>
                <QuinielaDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quinielas/:id/predictions/:participationId"
            element={
              <ProtectedRoute>
                <QuinielaPredictions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallet"
            element={
              <ProtectedRoute>
                <Wallet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operator"
            element={
              <ProtectedRoute requiredRole="operator">
                <OperatorPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operator/create-quiniela"
            element={
              <ProtectedRoute requiredRole="operator">
                <CreateQuiniela />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operator/quiniela/:id/edit"
            element={
              <ProtectedRoute requiredRole="operator">
                <EditQuiniela />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operator/quiniela/:id/results"
            element={
              <ProtectedRoute requiredRole="operator">
                <QuinielaResults />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operator/payments"
            element={
              <ProtectedRoute requiredRole="operator">
                <ValidarPagos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operator/withdrawals"
            element={
              <ProtectedRoute requiredRole="operator">
                <Withdrawals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operator/usuarios"
            element={
              <ProtectedRoute requiredRole="operator">
                <Usuarios />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* 404 */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  )
}

export default App
